/**
 * Gets the repositories of the user from Github
 */

import { call, put, takeLatest } from "redux-saga/effects";
import { API_URL, translate } from "utils/constants";
import { Res, request } from "utils/request";
import { actions, logoutSuccess } from "./slice";
import { User } from "app/types";
import { LoginResponse } from "app/containers/Auth/containers/LoginPage/types";
import toastService from "utils/toast";
import { removeBlankProperties } from "utils/helpers";
import { Organization, OrganizationListResponse } from "app/containers/Organizations/types";
import { Query } from "app/containers/types";
import { actions as authAction } from 'app/redux/slice';

export function* logoutRequest() {
  try {
    // const response = yield request(`${API_URL}/auth/logout`, options);
    // if (response) {
    //   yield localStorage.setItem("sessionToken", "");
    // }
    yield localStorage.clear();
  } catch (err: any) {
  }


  yield put(logoutSuccess());
}

export function* getUserRequest() {
  try {
    const requestURL = `${API_URL}/v1/auth/user/me`;
    const options = {
      method: "GET",
    };
    const {data, err, status}: Res<{ data: User }> = yield call(request, requestURL, options);

    if(err || !data){
      throw err;
    }
    yield put(actions.setUser(data?.data));
  } catch (err: any) {
    if(err.message == 'Failed to refresh token') {
      yield put (actions.logout())
      window.location.reload()
        return 
    }
    toastService.error(translate("COMMON.ERRORS.MESSAGE"));
  }
}


export function* getOrganizationsRequest({payload}: { payload: Query }) { 
    try {
        payload.isActive = 'true'
        const query = new URLSearchParams(removeBlankProperties(payload)).toString();

        const {data, err, status}: Res<OrganizationListResponse> = yield call(request, `${API_URL}/v1/admin/organization/list?${query}`);
        
        if(err || !data){
            throw err;
        }
        yield put(actions.setOrganizations(data));
        return data
    } catch (error:any) {
        yield put(actions.getOrganizationError());
        let errorMessage = error?.message;
        try {
          errorMessage = JSON.parse(errorMessage);
        } catch (e) {
        }
        toastService.error(errorMessage?.message || errorMessage || translate("COMMON.ERRORS.MESSAGE"));
    }
}

export function* setOrganizationRequest({payload}: { payload: { label: string; value: string } }) {
    try {
        yield localStorage.setItem("organization", JSON.stringify(payload));
    } catch (error:any) {
        toastService.error(translate("COMMON.ERRORS.MESSAGE"));
    }
}
export function* setToCurrentOrganizationRequest({payload}: { payload: string }) {
  try {
    const res: OrganizationListResponse = yield getOrganizationsRequest({payload: {search: payload}})
    if(res.data && res.data.length){
      const org =  res.data[0]
      if(org._id == payload) {
        yield put(actions.setOrganization({label: org.name, value: org._id}))
      }
    }
  } catch (error:any) {
     console.log({error})
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* authSaga() {
  // Watches for LOAD_REPOS actions and calls loginResponse when one comes in.
  // By using `takeLatest` only the result of the latest API call is applied.
  // It returns task descriptor (just like fork) so we can continue execution
  // It will be cancelled automatically on component unmount
  yield takeLatest(actions.logout, logoutRequest);
  yield takeLatest(actions.getUser, getUserRequest);
  yield takeLatest(actions.getOrganizations, getOrganizationsRequest);
  yield takeLatest(actions.setOrganization, setOrganizationRequest);
  yield takeLatest(actions.setToCurrentOrganization, setToCurrentOrganizationRequest);
}
